export default __webpack_public_path__ + "media/zurb/img/ecommerce/shopping_flow2-452dff390856232021c944b263e818a5.png";